import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import { Trash } from 'react-feather';

const MaterialImportItemForm = ({
    item,
    index,
    materialOptions,
    onChange,
    onRemove,
    isForSpecialSale
}) => {
    // Find the selected material from materialOptions to get its unit
    // Handle both string and number material_id values
    const selectedMaterial = materialOptions?.find(option => 
        option.value === item.material_id || 
        option.value === Number(item.material_id) ||
        String(option.value) === String(item.material_id)
    );
    const unitName = selectedMaterial?.unit?.name || '';
    const unitSymbol = selectedMaterial?.unit?.symbol || '';
    
    return (
        <div className="border rounded p-3 mb-3 position-relative">
            <div className="row">
                <div className="col-md-4">
                    <Form.Group className="mb-3">
                        <Form.Label>Material</Form.Label>
                        <Select
                            value={materialOptions.find(option => option.value === Number(item.material_id) || option.value === item.material_id)}
                            onChange={(selected) => onChange(index, 'material_id', selected.value)}
                            options={materialOptions}
                            placeholder="Materialni tanlang..."
                            isSearchable={true}
                        />
                    </Form.Group>
                </div>
                <div className={isForSpecialSale ? "col-md-6" : "col-md-3"}>
                    <Form.Group className="mb-3">
                        <Form.Label>Miqdori</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type="number"
                                placeholder="Miqdorni kiriting"
                                value={item.quantity}
                                onChange={(e) => onChange(index, 'quantity', e.target.value)}
                                required
                            />
                            {unitName && (
                                <InputGroup.Text>
                                    {unitSymbol || unitName}
                                </InputGroup.Text>
                            )}
                        </InputGroup>
                    </Form.Group>
                </div>
                {!isForSpecialSale && (
                    <div className="col-md-3">
                        <Form.Group className="mb-3">
                            <Form.Label>Narxi</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Narxni kiriting"
                                value={item.price}
                                onChange={(e) => onChange(index, 'price', e.target.value)}
                                required
                            />
                        </Form.Group>
                    </div>
                )}
                <div className="col-md-2 d-flex align-items-end">
                    <Button 
                        variant="outline-danger" 
                        className="mb-3"
                        onClick={() => onRemove(index)}
                    >
                        <Trash size={16} />
                    </Button>
                </div>
            </div>
        </div>
    );
};

MaterialImportItemForm.propTypes = {
    item: PropTypes.shape({
        material_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        price: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }).isRequired,
    index: PropTypes.number.isRequired,
    materialOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
        unit: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            symbol: PropTypes.string
        }),
        unit_alternative: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            symbol: PropTypes.string
        })
    })).isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    isForSpecialSale: PropTypes.bool
};

MaterialImportItemForm.defaultProps = {
    isForSpecialSale: false
};

export default MaterialImportItemForm;
